import React from "react";
import "./Skills.css";
import {
  FaHtml5,
  FaCss3Alt,
  FaJs,
  FaReact,
  FaNodeJs,
  FaGitAlt,
  FaFigma,
} from "react-icons/fa";
import {
  SiTailwindcss,
  SiMongodb,
  SiFirebase,
} from "react-icons/si";

export default function Skills() {
  const skills = [
    { name: "HTML", icon: <FaHtml5 color="#e34c26" /> },
    { name: "CSS", icon: <FaCss3Alt color="#264de4" /> },
    { name: "JavaScript", icon: <FaJs color="#f0db4f" /> },
    { name: "React", icon: <FaReact color="#61dafb" /> },
    { name: "Node.js", icon: <FaNodeJs color="#3c873a" /> },
    { name: "Git", icon: <FaGitAlt color="#f1502f" /> },
    { name: "Tailwind", icon: <SiTailwindcss color="#38bdf8" /> },
    { name: "MongoDB", icon: <SiMongodb color="#4db33d" /> },
    { name: "Firebase", icon: <SiFirebase color="#ffcb2b" /> },
    { name: "Figma", icon: <FaFigma color="#a259ff" /> },
  ];

  return (
    <section id="skills" className="skills">
      <h3>My Skills</h3>
      <div className="skills-list">
        {skills.map((skill, index) => (
          <div key={index} className="skill-item">
            <div className="icon">{skill.icon}</div>
            <span>{skill.name}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
